import { Component, inject, input } from '@angular/core';
import { HlmButton } from '../../../ui/button/src';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideArrowLeft } from '@ng-icons/lucide';
import { HlmIcon } from '../../../ui/icon/src';
import { Router } from '@angular/router';
import { LayoutService } from '@core/services/layout.service';

@Component({
  selector: 'app-navigate-back',
  templateUrl: './navigate-back.component.html',
  styleUrls: ['./navigate-back.component.scss'],
  imports: [HlmButton, NgIcon, HlmIcon],
  providers: [provideIcons({ lucideArrowLeft })],
})
export class NavigateBackComponent {
  private router = inject(Router);
  private layoutSrv = inject(LayoutService);

  mobile = this.layoutSrv.isMobileView;

  readonly redirectTo = input<string[]>([]);

  navigateBack(): void {
    const redirectTo = this.redirectTo();
    if (redirectTo && redirectTo.length > 0) {
      this.router.navigate(redirectTo);
    } else {
      const splitted = this.router.url.split('/').filter(path => path !== '');
      splitted.pop();
      this.router.navigate(splitted.length > 0 ? splitted : ['']);
    }
  }
}
